
export type { VueOptions } from './vueOptions';
export type { NuxtOptions } from './nuxtOptions';
